<template>
    <div class="myexam">
        <!-- <Loading :loadingHide="loadingHide"></Loading>
        <Header></Header> -->
        <div class=" tabsBox">
            <el-tabs  v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="待考" name="first">
                    <ExamList @changeLoading="closeLoading" v-if="type == '待考'" :type="type"></ExamList>
                </el-tab-pane>
                <el-tab-pane label="已完成" name="second">
                    <ExamList v-if="type == '已完成'" :type="type"></ExamList>
                </el-tab-pane>
                <el-tab-pane label="缺考" name="third">
                    <ExamList v-if="type == '缺考'" :type="type"></ExamList>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- <Foot></Foot> -->
    </div>
</template>
<script>
import Header from '@/components/header';
import Foot from '@/components/foot';
import Loading from '@/components/loading';
import ExamList from '@/components/examList';

export default {
    components: {
        Header,
        Foot,
        ExamList,
        Loading
    },
    data() {
        return {
            type: "待考",
            activeName: "first",
            loadingHide: false
        }
    },
    methods: {
        //点击tab
        handleClick(value) {
            this.type = value.label
        },
        //关闭loading
        closeLoading() {
            this.loadingHide = true;
        }
    },
}
</script>
<style lang="scss">
.myexam .tabsBox {
    // padding: 80px 10px;
    // min-height: 760px;
    .el-tabs__item.is-active {
        color: var(--theme-activeColor);
    }
    .el-tabs__active-bar {
        background-color: var(--theme-activeColor);
    }
    .el-tabs__item:hover {
        color: var(--theme-color);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/exam/myexam.vue